import React, { useState } from "react";

import BuilderModal from "../../../../../../Layouts/Modal/BuilderModal";
import TableTreeModal from "../../../../../../components/BuilderComponents/TableTreeModal";
import { useAppBlocksContext } from "../../../../../../context/AppBlocksContext";
import EditCustomColumn from "./EditCustomColumn";
import EditFieldColumn from "./EditFieldColumn";
import ListOfColumns from "./ListOfColumns";
import Button from "../../../../../../components/FormComponents/Button";
import MaterialIcon from "../../../../../../components/BuilderComponents/MaterialIcon";
import { generateObjectId } from "../../../../../../utils/objectIdUtils";
import { toastError } from "../../../../../../utils/toastUtils";

const EditColumns = ({ afterEffectOfFilter, tableRef, setNonSelectedFilter }) => {
  const { recordsviewLayout, setRecordsviewLayout } = useAppBlocksContext();
  const [editColumn, setEditColumn] = useState({
    show: false,
    payload: null
  });
  const [isModalOpen, setIsModalOpen] = useState(false);

  const addCustomColumn = () => {
    const newColumn = {
      aggregate_column: "",
      aggregate_function: "",
      custom_type: "button",
      type: "custom",
      display: "custom",
      config: [],
      id: generateObjectId()
    };

    const updatedColumns = [...recordsviewLayout.columns, newColumn];
    const updatedLayout = { ...recordsviewLayout, columns: updatedColumns };
    setRecordsviewLayout(updatedLayout);
    showEditColumnBar(updatedColumns.length - 1, newColumn.id);
    afterEffectOfFilter(updatedLayout);
  };

  const handleChangeField = (data) => {
    setRecordsviewLayout((prevLayout) => {
      const newRecordviewLayout = { ...prevLayout };
      newRecordviewLayout.columns[editColumn.payload.index] = data;
      return newRecordviewLayout;
    });
  };

  const addFieldCallbackFunction = (data) => {
    if (recordsviewLayout.columns.some((field) => field.id === data.id)) {
      toastError("Field already exists");
      return;
    }

    const updatedColumns =
      isModalOpen === "add"
        ? [...recordsviewLayout.columns, data]
        : recordsviewLayout.columns.map((col, idx) => (idx === isModalOpen ? data : col));

    const updatedLayout = { ...recordsviewLayout, columns: updatedColumns };
    setRecordsviewLayout(updatedLayout);
    // setIsModalOpen(false);
    afterEffectOfFilter(updatedLayout);
  };

  const showEditColumnBar = (index, id, subIndex = null, subId = null) => {
    setEditColumn({
      show: true,
      payload: { index, id, subIndex, subId }
    });
  };

  const renderConfigComponent = () => {
    const { index } = editColumn.payload || {};
    const column = recordsviewLayout.columns?.[index];
    if (!editColumn.show || !column) return null;

    if (column.type === "field") {
      return (
        <EditFieldColumn
          field={recordsviewLayout.columns[editColumn.payload.index]}
          tableId={recordsviewLayout.table_id}
          handleChangeField={handleChangeField}
        />
      );
    }

    if (column.type === "custom") {
      return (
        <EditCustomColumn
          showEditColumnBar={showEditColumnBar}
          editColumn={editColumn}
          tableRef={tableRef}
          table_id={recordsviewLayout.table_id}
          activity_id={recordsviewLayout.activity_id}
          afterEffectOfFilter={afterEffectOfFilter}
          setNonSelectedFilter={setNonSelectedFilter}
        />
      );
    }

    return null;
  };

  return (
    <>
      <div className="edit_recordsview_column_container">
        <div className="edit_recordsview_left_panel">
          <div className="left_panel_button_container">
            {/* <Button onClick={addCustomColumn} className="left_panel_button custom_button"> */}
            <div
              className="d_flex gap_1 align_center color_secondary font_weight_bold cursor_pointer"
              onClick={addCustomColumn}
            >
              <MaterialIcon name="add" className="font_size_medium" />
              <p>Custom column</p>
            </div>
            {/* </Button> */}
            <Button
              variant="secondary"
              className="builder_btn_secondary_small d_flex g_4 builder_bold_text_primary"
              onClick={() => setIsModalOpen("add")}
            >
              <MaterialIcon name="add" className="icon_inside_btn" />
              <p>Add fields</p>
            </Button>
          </div>
          <ListOfColumns
            editColumn={editColumn}
            tableRef={tableRef}
            afterEffectOfFilter={afterEffectOfFilter}
            setIsModalOpen={setIsModalOpen}
            showEditColumnBar={showEditColumnBar}
            setEditColumn={setEditColumn}
          />
        </div>
        <hr className="edit_recordview_panel_break_line" />
        <div className="edit_recordsview_right_panel pt_3 pl_3">
          <div>{renderConfigComponent()}</div>
        </div>
      </div>
      <BuilderModal
        isOpen={isModalOpen === "add" || typeof isModalOpen === "number"}
        onClose={() => setIsModalOpen(false)}
        modalName={isModalOpen === "add" ? "Add form field" : "Edit form field"}
      >
        <TableTreeModal
          callbackFunction={addFieldCallbackFunction}
          tableId={recordsviewLayout.table_id}
          selectedFile={
            isModalOpen !== "add" && typeof isModalOpen === "number" ? recordsviewLayout.columns[isModalOpen]?.id : ""
          }
        />
      </BuilderModal>
    </>
  );
};

export default EditColumns;
